"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timelock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "AddReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "AddReservesOverflow",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "minWaitInSeconds",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "available",
                type: "uint256",
            },
        ],
        name: "AggregateValueRateLimitReached",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowAndDepositBackFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "BorrowPaused",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "usdThreshold",
                type: "uint256",
            },
        ],
        name: "BorrowValueMustBeLargerThanThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "CantEnterPausedMarket",
        type: "error",
    },
    {
        inputs: [],
        name: "CantExitMarketWithNonZeroBorrowBalance",
        type: "error",
    },
    {
        inputs: [],
        name: "CantSweepUnderlying",
        type: "error",
    },
    {
        inputs: [],
        name: "ComptrollerMismatch",
        type: "error",
    },
    {
        inputs: [],
        name: "EitherAssetOrDebtMustBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "groupId",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "cDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suDepositVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "cBorrowVal",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "suBorrowVal",
                type: "uint256",
            },
        ],
        name: "EitherAssetOrDebtMustBeZeroInGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "ExpiredSignature",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientCollateral",
        type: "error",
    },
    {
        inputs: [],
        name: "InsufficientShortfall",
        type: "error",
    },
    {
        inputs: [],
        name: "InterMintNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAddress",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidBlockNumber",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidCloseFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidComptroller",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidDiscountRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidExchangeRate",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidGroupId",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInput",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInterestRateModel",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidMinSuBorrowValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReduceAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidReserveFactor",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureForRedeemFaceValue",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSignatureLength",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidTimestamp",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsMax",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_RepayAmountIsZero",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateBorrow_SeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateCollateralMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "LiquidateMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketAlreadyUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketCanOnlyInitializeOnce",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotEmpty",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "MarketPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MinDelayNotReached",
        type: "error",
    },
    {
        inputs: [],
        name: "MintMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "MintPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "MintTokensCantBeZero",
        type: "error",
    },
    {
        inputs: [],
        name: "NoRedemptionProvider",
        type: "error",
    },
    {
        inputs: [],
        name: "NotCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughForSeize",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemAmount",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughRedeemTokens",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingAfterRedeem",
        type: "error",
    },
    {
        inputs: [],
        name: "NotEnoughUnderlyingForMint",
        type: "error",
    },
    {
        inputs: [],
        name: "NotLiquidatableYet",
        type: "error",
    },
    {
        inputs: [],
        name: "NotSuToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyAdminOrPauser",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyListedCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPausedMarketCanBeUnlisted",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyPendingAdmin",
        type: "error",
    },
    {
        inputs: [],
        name: "OnlyRedemptionManager",
        type: "error",
    },
    {
        inputs: [],
        name: "OverThreshold",
        type: "error",
    },
    {
        inputs: [],
        name: "PriceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ProtectedMint_OnlyAllowAssetsInTheSameGroup",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RedeemTransferOutNotPossible",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSeizeTooMuch",
        type: "error",
    },
    {
        inputs: [],
        name: "RedemptionSignerNotInitialized",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesCashNotAvailable",
        type: "error",
    },
    {
        inputs: [],
        name: "ReduceReservesMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "Reentered",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayBorrowMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "RepayTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizePaused",
        type: "error",
    },
    {
        inputs: [],
        name: "SeizeTokenNotListed",
        type: "error",
    },
    {
        inputs: [],
        name: "Seize_LiquidatorIsBorrower",
        type: "error",
    },
    {
        inputs: [],
        name: "SenderMustBeCToken",
        type: "error",
    },
    {
        inputs: [],
        name: "SetInterestRateModelMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SetReservesFactorMarketNotFresh",
        type: "error",
    },
    {
        inputs: [],
        name: "SupplyCapReached",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenInOrAmountInMustBeZero",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "minWaitInSeconds",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "available",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "tokenAddress",
                type: "address",
            },
        ],
        name: "TokenRateLimitReached",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferInFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TokenTransferOutFailed",
        type: "error",
    },
    {
        inputs: [],
        name: "TooMuchRepay",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalBorrowsNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TotalSupplyNotZero",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferNotAllowed",
        type: "error",
    },
    {
        inputs: [],
        name: "TransferPaused",
        type: "error",
    },
    {
        inputs: [],
        name: "UnderlyingBalanceError",
        type: "error",
    },
    {
        inputs: [],
        name: "ZeroAddressNotAllowed",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum ITimelock.TimeLockActionType",
                name: "actionType",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "AgreementClaimed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "asset",
                type: "address",
            },
            {
                indexed: false,
                internalType: "enum ITimelock.TimeLockActionType",
                name: "actionType",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
        ],
        name: "AgreementCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "value",
                type: "bool",
            },
        ],
        name: "AgreementFrozen",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "isEnabled",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "capacity",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "rate",
                        type: "uint256",
                    },
                ],
                indexed: false,
                internalType: "struct RateLimiter.Config",
                name: "config",
                type: "tuple",
            },
        ],
        name: "ConfigChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldRate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newRate",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "oldCapacity",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newCapacity",
                type: "uint256",
            },
        ],
        name: "NewLimiter",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "oldValue",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "newValue",
                type: "uint48",
            },
        ],
        name: "NewMaxDelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint48",
                name: "oldValue",
                type: "uint48",
            },
            {
                indexed: false,
                internalType: "uint48",
                name: "newValue",
                type: "uint48",
            },
        ],
        name: "NewMinDelay",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldValue",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newValue",
                type: "uint256",
            },
        ],
        name: "NewThreshold",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "address",
                name: "underlyToken",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "underlyAmount",
                type: "uint256",
            },
        ],
        name: "RescueAgreement",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "previousAdminRole",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "newAdminRole",
                type: "bytes32",
            },
        ],
        name: "RoleAdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleGranted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                indexed: true,
                internalType: "address",
                name: "account",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "sender",
                type: "address",
            },
        ],
        name: "RoleRevoked",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "value",
                type: "bool",
            },
        ],
        name: "TimeLockFrozen",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "tokens",
                type: "uint256",
            },
        ],
        name: "TokensConsumed",
        type: "event",
    },
    {
        inputs: [],
        name: "DEFAULT_ADMIN_ROLE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "EMERGENCY_ADMIN",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "agreementCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "agreements",
        outputs: [
            {
                internalType: "bool",
                name: "isFrozen",
                type: "bool",
            },
            {
                internalType: "enum ITimelock.TimeLockActionType",
                name: "actionType",
                type: "uint8",
            },
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
            {
                internalType: "uint48",
                name: "timestamp",
                type: "uint48",
            },
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "underlyAmount",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "balances",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "agreementIds",
                type: "uint256[]",
            },
        ],
        name: "claim",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "comptroller",
        outputs: [
            {
                internalType: "contract IComptroller",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "underlyAmount",
                type: "uint256",
            },
        ],
        name: "consumeValue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "underlyAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "cToken",
                type: "address",
            },
        ],
        name: "consumeValuePreview",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "enum ITimelock.TimeLockActionType",
                name: "actionType",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "underlyAmount",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "beneficiary",
                type: "address",
            },
        ],
        name: "createAgreement",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "currentState",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "tokens",
                        type: "uint256",
                    },
                    {
                        internalType: "uint32",
                        name: "lastUpdated",
                        type: "uint32",
                    },
                    {
                        internalType: "bool",
                        name: "isEnabled",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "capacity",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "rate",
                        type: "uint256",
                    },
                ],
                internalType: "struct RateLimiter.TokenBucket",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "freeze",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "freezeAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "frozen",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "getMinWaitInSeconds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleAdmin",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "index",
                type: "uint256",
            },
        ],
        name: "getRoleMember",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
        ],
        name: "getRoleMemberCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "grantRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "hasRole",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_admin",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "rate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "capacity",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_threshold",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "isAgreementMature",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "minDelay",
        outputs: [
            {
                internalType: "uint48",
                name: "",
                type: "uint48",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "renounceRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "to",
                type: "address",
            },
        ],
        name: "rescueAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "role",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "revokeRole",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_comptroller",
                type: "address",
            },
        ],
        name: "setComptroller",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newRate",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newCapacity",
                type: "uint256",
            },
        ],
        name: "setLimiter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newMaxDelayInSeconds",
                type: "uint48",
            },
        ],
        name: "setMaxDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint48",
                name: "newMinDelayInSeconds",
                type: "uint48",
            },
        ],
        name: "setMinDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "isEnabled",
                        type: "bool",
                    },
                    {
                        internalType: "uint256",
                        name: "capacity",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "rate",
                        type: "uint256",
                    },
                ],
                internalType: "struct RateLimiter.Config",
                name: "config",
                type: "tuple",
            },
        ],
        name: "setRateLimiterConfig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newThreshold",
                type: "uint256",
            },
        ],
        name: "setThreshold",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "threshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "unfreeze",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "agreementId",
                type: "uint256",
            },
        ],
        name: "unfreezeAgreement",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "user",
                type: "address",
            },
        ],
        name: "userAgreements",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "isFrozen",
                        type: "bool",
                    },
                    {
                        internalType: "enum ITimelock.TimeLockActionType",
                        name: "actionType",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "cToken",
                        type: "address",
                    },
                    {
                        internalType: "address",
                        name: "beneficiary",
                        type: "address",
                    },
                    {
                        internalType: "uint48",
                        name: "timestamp",
                        type: "uint48",
                    },
                    {
                        internalType: "uint256",
                        name: "agreementId",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "underlyAmount",
                        type: "uint256",
                    },
                ],
                internalType: "struct ITimelock.Agreement[]",
                name: "",
                type: "tuple[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Timelock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Timelock__factory = Timelock__factory;
Timelock__factory.bytecode = _bytecode;
Timelock__factory.abi = _abi;
//# sourceMappingURL=Timelock__factory.js.map